import React, { useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';

import { useNavigate } from 'react-router-dom'; 

const AddLocation = () => {
  const [isLotRequired, setIsLotRequired] = useState(false);
  const [allowNoteForLot, setAllowNoteForLot] = useState(false);
  const [isSerialRequired, setIsSerialRequired] = useState(false);
  const [allowNoteForSerial, setAllowNoteForSerial] = useState(false);
  
  const navigate = useNavigate(); 
  const handleLotRequiredChange = (e) => {
    setIsLotRequired(e.target.checked);
    if (!e.target.checked) setAllowNoteForLot(false);
  };

  const handleSerialRequiredChange = (e) => {
    setIsSerialRequired(e.target.checked);
    if (!e.target.checked) setAllowNoteForSerial(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const locationData = {
      valueName: e.target[0].value, 
      isLotRequired,
      allowNoteForLot,
      isSerialRequired,
      allowNoteForSerial,
    };

    try {
      const response = await fetch('https://hms.backend.hiragroupcloud.com/api/add-location', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(locationData),
      });

      if (response.ok) {
        const result = await response.json();
        alert('Location added successfully!');
        
        
        // Redirect to the Overview Settings page
        navigate('/owersetting'); // Adjust the path as necessary
      } else {
        alert('Error adding location');
      }
    } catch (error) {
      console.error('Error:', error);
    }
  };

  return (
    <div style={{width:"1600px"}}>
          <div className="col-md-10">
            <h2 className="title">Add Location</h2>
            <h4 style={{color:"#004aad" }}>
              Details
            </h4>
            <form className="p-4 " onSubmit={handleSubmit}>
              <div style={{backgroundColor:"#f4f4f4",padding:"10px",borderTop:"2px solid #004aad"}}>
              <div className="mb-3">
                <label className="form-label" style={{ fontWeight: "bold" }}>Value Name *</label>
                <input type="text" className="form-control" placeholder="Enter Value Name" />
              </div>
              <div className="mb-3">
                <label className="form-label" style={{ fontWeight: "bold" }}>Lot #</label>
                <div className="form-check">
                  <input
                    type="checkbox"
                    className="form-check-input"
                    checked={isLotRequired}
                    onChange={handleLotRequiredChange}
                  />
                  <label className="form-check-label">Is Required</label>
                </div>
                <div className="form-check">
                  <input
                    type="checkbox"
                    className="form-check-input"
                    checked={allowNoteForLot}
                    onChange={(e) => setAllowNoteForLot(e.target.checked)}
                    disabled={!isLotRequired} 
                  />
                  <label className="form-check-label">Allow Note</label>
                </div>
              </div>
              <div className="mb-3">
                <label className="form-label" style={{ fontWeight: "bold" }}>Serial #</label>
                <div className="form-check">
                  <input
                    type="checkbox"
                    className="form-check-input"
                    checked={isSerialRequired}
                    onChange={handleSerialRequiredChange}
                  />
                  <label className="form-check-label">Is Required</label>
                </div>
                <div className="form-check">
                  <input
                    type="checkbox"
                    className="form-check-input"
                    checked={allowNoteForSerial}
                    onChange={(e) => setAllowNoteForSerial(e.target.checked)}
                    disabled={!isSerialRequired} 
                  />
                  <label className="form-check-label">Allow Note</label>
                </div>
              </div>
              </div>
              <button type="submit" className="btn btn-primary" style={{backgroundColor:"#004aad",borderColor:"#004aad"}}>Save</button>
            </form>
          </div>
        </div>
    
  );
};

export default AddLocation;
